(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('PriceInfoDtailCustom', PriceInfoDtailCustom);

    PriceInfoDtailCustom.$inject = ['$resource'];

    function PriceInfoDtailCustom($resource) {


        var PriceInfoDtailsByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/price-info-dtails-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var PriceInfoDtailByServiceTimeSession = function (serviceItemId, serviceTimeSessionId) {
            var resourceUrl = 'api/price-info-dtails-by-service-time-session/' + serviceItemId + '/' + serviceTimeSessionId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        var deletePriceInfoDtailById = function () {

            var resourceUrl = 'api/delete-price-info-dtail-by-id';
            return $resource(resourceUrl, {}, {}
            );
        };


        var getPriceInfoDtailByServiceItemFromDate = function (serviceId, servantId, fromDate) {
            var resourceUrl = 'api/price-info-dtails-by-service-item-from-date?serviceItemId=' + serviceId + '&fromDate=' + fromDate;
            if (servantId)
                resourceUrl += "&servantId=" + servantId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        return {
            PriceInfoDtailsByServiceItem: PriceInfoDtailsByServiceItem,
            PriceInfoDtailByServiceTimeSession: PriceInfoDtailByServiceTimeSession,
            deletePriceInfoDtailById: deletePriceInfoDtailById,
            getPriceInfoDtailByServiceItemFromDate: getPriceInfoDtailByServiceItemFromDate
        };
    }
})();
